import { useContext, useEffect, useRef, useState } from "react";
import { SnackBarContext } from "../../contexts/SnackBarContext";
import { Alert, duration, Fade, Snackbar } from "@mui/material";
import './SnackBar.scss';
import { environment } from "../../environments/environment";

const emptyState = {
  title: "",
  open: false,
  message: "",
  duration: 3000,
  type: "info"
};
export const SnackBar = () => {
  const { snackbarState, setSnackbarState } = useContext(SnackBarContext);
  const [localState, setLocalState] = useState({ ...emptyState });
  const timer = useRef();

  useEffect(() => {
    setLocalState(snackbarState);
    if (snackbarState.open) {
      if (snackbarState.duration !== "pin") timer.current = setTimeout(() => {
        setLocalState(prev => ({ ...prev, open: false }));
      }, snackbarState.duration ?? environment.snackbarsDisappearanceTime)
    }
    return () => {
      clearTimeout(timer.current)
    }
  }, [snackbarState]);

  const onClose = () => {
    // setLocalOpen(false);
    clearTimeout(timer.current);
    setLocalState(prev => ({ ...prev, open: false }));

  }

  return (
    <Snackbar TransitionComponent={Fade} open={Boolean(localState.open)} autoHideDuration={(localState.duration === "pin") ? undefined : (localState.duration ?? environment.snackbarsDisappearanceTime)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <div className={`snackbar-component ${localState.type}`}>
        <i className={`icon-${localState.type} alert-indicator-icon`}></i>
        <div className="snackbar-content">
          {localState.title && <b>{localState.title}</b>}
          {Boolean(localState.message) && <span>{localState.message}</span>}
        </div>
        <i className={`icon-light-cross`} onClick={onClose}></i>
      </div>
    </Snackbar>
  )
}